import { NotFoundRoute } from './pages/404/route';
import { LoginRoute, UnauthenticatedHomepage } from './pages/Login/route';

export const routesUnauth = [
  LoginRoute,
  NotFoundRoute,
  UnauthenticatedHomepage,
] as const;
